import { isEmpty } from 'lodash';
import type from './User.type';
import { rightsArray } from './rightsArray';

const initialState = {
  documentsList: [],
  userGroupsCardList: [],
  userGroupsDetails: null,
  usersLibraryList: [],
  usersLibraryTotalRecords: 0,
  supplierUsersList: [],
  supplierUsersTotalRecords: 0,
  userFetchOption: [],
  logInRights: [],
  moduleAccess: {},
  sectionAccess: {},
  subscriptionDetails: {},
  profileDetails: {},
  currencyPermission: '',
  usedStorageBySystem: '0',
};

const moduleObj = [
  'products',
  'libraries',
  'rangePlan',
  'criticalPath',
  'planning',
  'placeholder',
  'supplierOverview',
  'manuals',
  'masters',
  'pim',
  'dam',
  'dpp',
];

const getAllModulesAccessRights = (rights) => {
  const userRights = rights?.length ? rights : [];
  const returnObj = {};
  userRights?.forEach((ele) => {
    moduleObj?.forEach((moduleName) => {
      if (ele?.rights?.[moduleName]?.[0]?.section) {
        returnObj[`${moduleName}Access`] = ele.rights[moduleName][0].section.switchStatus;
      } else {
        returnObj[`${moduleName}Access`] = false;
      }
    });
  });
  return returnObj;
};

const getAllSectionAccessRights = (rights) => {
  const userRights = rights?.length ? rights : [];
  const returnObj = {};
  userRights?.forEach((ele) => {
    moduleObj.forEach((moduleName) => {
      returnObj[moduleName] = {};
      ele?.rights?.[moduleName]?.forEach((sectionName) => {
        if (sectionName?.module) {
          returnObj[moduleName][`${sectionName.module}Access`] = sectionName?.switchstatus;
        }
      });
    });
  });
  return returnObj;
};

const getAllAdminModulesAccessRights = () => {
  const returnObj = {};
  moduleObj?.forEach((moduleName) => {
    returnObj[`${moduleName}Access`] = true;
  });
  return returnObj;
};

const getAllAdminSectionAccessRights = () => {
  const userRights = rightsArray;
  const returnObj = {};

  userRights?.forEach((ele) => {
    moduleObj.forEach((moduleName) => {
      returnObj[moduleName] = {};
      ele?.rights?.[moduleName]?.forEach((sectionName) => {
        if (sectionName?.module) {
          returnObj[moduleName][`${sectionName.module}Access`] = true;
        }
      });
    });
  });
  return returnObj;
};

const UsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_USER_RIGHTS: {
      const sectionRights = getAllSectionAccessRights(action.payload);
      const moduleRightsRights = getAllModulesAccessRights(action.payload);
      return {
        ...state,
        moduleAccess: moduleRightsRights,
        sectionAccess: sectionRights,
        logInRights: action.payload,
      };
    }
    case type.ADMIN_RIGHTS_ACCESS: {
      const section = getAllAdminSectionAccessRights();
      const moduleRights = getAllAdminModulesAccessRights();
      return {
        ...state,
        moduleAccess: moduleRights,
        sectionAccess: section,
        logInRights: action.payload,
      };
    }
    case type.USER_DOCS:
      return {
        ...state,
        documentsList: action.payload,
      };

    case type.GET_USERS_GROUPS_CARD:
      return {
        ...state,
        userGroupsCardList: action.payload,
      };
    case type.GET_USERGROUPS_BYID:
      return {
        ...state,
        userGroupsDetails: action.payload,
      };
    // *****library*****
    case type.GET_USERS_LIBRARY_LIST:
      return {
        ...state,
        usersLibraryList: Array.isArray(action.payload) ? action.payload : (action.payload.list || []),
        usersLibraryTotalRecords: Array.isArray(action.payload) ? 0 : (action.payload.totalRecords || 0),
      };
    case type.GET_SUPPLIER_USERS_LIST:
      return {
        ...state,
        supplierUsersList: Array.isArray(action.payload) ? action.payload : (action.payload.list || []),
        supplierUsersTotalRecords: Array.isArray(action.payload) ? 0 : (action.payload.totalRecords || 0),
      };
    case type.FETCH_OPTIONS:
      return {
        ...state,
        userFetchOption: !isEmpty(action.payload) && [...action.payload],
      };
    case type.DELETE_USER_DOC: {
      const rows = [...state.documentsList];
      const i = action.payload;
      rows.splice(i, 1);
      return {
        ...state,
        documentsList: rows,
      };
    }
    case type.MODULE_ACCESS_RIGHTS:
      return {
        ...state,
        moduleAccess: action.payload,
      };

    case type.SECTION_ACCESS_RIGHTS:
      return {
        ...state,
        sectionAccess: action.payload,
      };
    case type.SUBSCRIPTION_PERMISSION:
      return {
        ...state,
        subscriptionDetails: action.payload,
      };
    case type.PROFILE_DETAILS:
      return {
        ...state,
        profileDetails: action.payload,
      };

    case type.CLEAR:
      return {
        ...state,
        documentsList: [],
      };
    case type.CURRENCY_PERMISSION:
      return {
        ...state,
        currencyPermission: action.payload,
      };
    case type.STORAGE_USER_BY_SYSTEM_BY_SLUG:
      return {
        ...state,
        usedStorageBySystem: action.payload,
      };

    default:
      return state;
  }
};

export default UsersReducer;
